import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { store } from '@/store'

export interface ErrorState {
    keys: string[]
    errors: { [key: string]: string }
}

export type ErrorPayload = {
    key: string,
    message?: string
}

@Module({ dynamic: true, store, name: 'errors' })
export class Errors extends VuexModule implements ErrorState {

    public keys: string[] = []
    public errors: { [key: string]: string } = {}

    @Mutation
    private SET_MESSAGE(errorPayload: ErrorPayload) {
        if (errorPayload.message) {
            if (this.keys.indexOf(errorPayload.key) === -1) {
                this.keys.push(errorPayload.key)
            }
            this.errors[errorPayload.key] = errorPayload.message
        } else {
            let idx = this.keys.indexOf(errorPayload.key)
            if (idx !== undefined && idx !== -1) {
                this.keys.splice(idx, 1)
                delete this.errors[errorPayload.key] 
            }
        }
    }

    @Action({ commit: 'SET_MESSAGE' })
    public SetError(error: ErrorPayload) {
        return error
    }
}

export const ErrorsModule = getModule(Errors)